import textBodyS from '@fukku/styles/texts/textBodyS.module.css'
import { cx } from 'classix'
import type { ReactNode, RefObject } from 'react'
import styles from '../Tooltip.module.css'

interface TooltipContentProps {
	readonly uniqueId: string
	readonly className?: string
	readonly tooltipStyles: React.CSSProperties
	readonly dataTestId?: string
	readonly preventHover: boolean
	readonly cancelCloseTimeout: () => void
	readonly handleClose: () => void
	readonly shouldDisplay: boolean
	readonly handleCloseAnimation: () => void
	readonly content: string | ReactNode
	readonly tooltipRef: RefObject<HTMLDivElement | null>
	readonly arrowStyles: React.CSSProperties
}

export const TooltipContent = ({
	uniqueId,
	className,
	tooltipStyles,
	dataTestId,
	preventHover,
	cancelCloseTimeout,
	handleClose,
	shouldDisplay,
	handleCloseAnimation,
	content,
	tooltipRef,
	arrowStyles,
}: TooltipContentProps) => (
	<div
		id={uniqueId}
		className={cx(
			className,
			styles.tooltip,
			Object.keys(tooltipStyles).length === 0 && styles.tooltipHidden
		)}
		role='tooltip'
		data-testid={dataTestId}
		onMouseEnter={preventHover ? undefined : cancelCloseTimeout}
		onMouseLeave={preventHover ? undefined : handleClose}
		data-display={shouldDisplay}
		onAnimationEnd={handleCloseAnimation}
	>
		<div
			className={cx(styles.content, textBodyS.className)}
			style={tooltipStyles}
			ref={tooltipRef}
		>
			{content}
		</div>
		<div className={styles.arrow} style={arrowStyles} />
	</div>
)
